/* Hiser header on every page except the homepage, which runs the same header from hiser-home.js */
(() => {
  const hdr = document.getElementById('hdr');
  const menuBtn = document.getElementById('menuBtn');
  const drawer = document.getElementById('drawer');
  if (!hdr || !menuBtn || !drawer) return;
  const wrapper = document.querySelector('.page-wrapper');
  const cartLink = hdr.querySelector('.hdr-cart');
  const cartDrawer = () => document.getElementById('cart-drawer');

  const track = (ev, p = {}) => {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', ev, p);
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, p));
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('hiser_' + ev, p);
    } catch (e) {}
  };

  // Phone and tablet menu
  const setMenu = open => {
    drawer.hidden = !open;
    menuBtn.setAttribute('aria-expanded', open);
    menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
    document.documentElement.classList.toggle('hz-menu-open', open);
    if (open) cartDrawer()?.close?.();
  };
  menuBtn.addEventListener('click', () => setMenu(drawer.hidden));
  drawer.addEventListener('click', e => { if (e.target.closest('a, button')) setMenu(false); });
  addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hidden) { setMenu(false); menuBtn.focus(); } });
  addEventListener('resize', () => { if (innerWidth > 1024 && !drawer.hidden) setMenu(false); });

  // Line under the header once the page scrolls. Wide screens scroll inside .page-wrapper, phones scroll the window.
  const onScroll = () => hdr.classList.toggle('scrolled', scrollY > 10 || (wrapper ? wrapper.scrollTop > 10 : false));
  addEventListener('scroll', onScroll, { passive: true });
  if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // The cart icon opens the theme's cart drawer; without it (e.g. on the cart page) the link goes to /cart
  if (cartLink) cartLink.addEventListener('click', e => {
    const d = cartDrawer();
    if (!d || typeof d.open !== 'function') return;
    e.preventDefault();
    setMenu(false);
    d.open();
  });

  // Keep the cart count in step when something is added or removed
  const renderCount = n => {
    if (!cartLink) return;
    let cnt = cartLink.querySelector('.cnt');
    if (n > 0) {
      if (!cnt) {
        cnt = document.createElement('span');
        cnt.className = 'cnt';
        cnt.setAttribute('aria-hidden', 'true');
        cartLink.append(cnt);
      }
      cnt.textContent = n > 99 ? '99+' : String(n);
      cartLink.setAttribute('aria-label', 'Cart, ' + n + ' items');
    } else {
      if (cnt) cnt.remove();
      cartLink.setAttribute('aria-label', 'Cart');
    }
  };
  document.addEventListener('shopify:cart:lines-update', e => {
    if (!e.promise) return;
    e.promise.then(r => renderCount((r && r.cart && r.cart.totalQuantity) ?? (r && r.detail && r.detail.itemCount) ?? 0)).catch(() => {});
  });
  addEventListener('pageshow', e => {
    if (!e.persisted) return;
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js')
      .then(r => r.json()).then(c => renderCount(c.item_count)).catch(() => {});
  });

  // Same WhatsApp event the homepage sends
  hdr.addEventListener('click', e => { if (e.target.closest('.hdr-wa')) track('whatsapp_click', { link_location: 'header' }); });
})();
